// extracted by mini-css-extract-plugin
export default {"page_title":"TitleBlock_page_title__-dRZO"};